import DTO from './DTO';

class ComplexDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'id',
        type: String,
        validators: {},
        labelKey: 'id',
      },
      {
        name: 'name',
        type: String,
        validators: {},
        labelKey: 'complex.name',
      },
      {
        name: 'serial_number',
        type: String,
        validators: {},
        labelKey: 'complex.serial.number',
      },
      {
        name: 'address',
        type: String,
        validators: {},
        labelKey: 'complex.address',
      },
      {
        name: 'auto_coordinates',
        type: String,
        validators: {},
        labelKey: 'auto.coordinates',
      },
      {
        name: 'longitude',
        type: String,
        validators: {},
        labelKey: 'longitude',
      },
      {
        name: 'latitude',
        type: String,
        validators: {},
        labelKey: 'latitude',
      },
      {
        name: 'use_decimal',
        type: Boolean,
        validators: {},
        labelKey: 'use_decimal',
      },
    ];
    super(attributes, params, isValidInit);
  }

  getData() {
    return {
      name: this.name,
      serial_number: this.serial_number,
      address: this.address,
      longitude: this.longitude,
      latitude: this.latitude,
    };
  }
}

export default ComplexDTO;
